import type { Exercise } from "../types/exercises";

export const lessonSpeechLang = "es-ES";

export const pictures = {
  bread: "https://cdn.magicpatterns.com/patterns/generated-images/c0aa0c71-9041-4e2f-a5f8-91580587b5c7.jpg",
  apple: "https://cdn.magicpatterns.com/patterns/generated-images/ca2259d3-8da0-45f0-a51c-d682419960e9.jpg",
  cheese: "https://cdn.magicpatterns.com/patterns/generated-images/edcf8acf-d6f4-49c3-9011-2d4e66351011.jpg",
  fish: "https://cdn.magicpatterns.com/patterns/generated-images/58a087e3-3989-40fc-b70d-21a05ca27fae.jpg",
  market: "https://cdn.magicpatterns.com/patterns/generated-images/be5adf8b-5cee-48af-bb27-1496290ab2e3.jpg",
};

export const marketLesson: Exercise[] = [
  {
    id: "ex-match-words",
    type: "match-words",
    pairs: [
      { term: "la manzana", translation: "the apple" },
      { term: "el queso", translation: "the cheese" },
      { term: "el pan", translation: "the bread" },
      { term: "barato", translation: "cheap" },
      { term: "el mercado", translation: "the market", fromTranslator: true },
    ],
  },
  {
    id: "ex-match-picture",
    type: "match-picture",
    prompt: "el queso",
    promptTranslation: "the cheese",
    answer: "cheese",
    options: [
      { id: "bread", label: "el pan", image: pictures.bread },
      { id: "cheese", label: "el queso", image: pictures.cheese },
      { id: "apple", label: "la manzana", image: pictures.apple },
      { id: "fish", label: "el pescado", image: pictures.fish },
    ],
  },
  {
    id: "ex-match-audio",
    type: "match-audio",
    fromTranslator: true,
    audio: "la bolsa",
    options: ["the box", "the bag", "the basket", "the bottle"],
    answer: "the bag",
  },
  {
    id: "ex-fill-gap",
    type: "fill-gap",
    before: "Quiero",
    after: "kilo de tomates, por favor.",
    translation: "I'd like a kilo of tomatoes, please.",
    options: ["una", "un", "unos", "el"],
    answer: "un",
  },
  {
    id: "ex-memory",
    type: "memory",
    pairs: [
      { term: "la naranja", translation: "the orange" },
      { term: "el tomate", translation: "the tomato" },
      { term: "la leche", translation: "the milk" },
      { term: "el huevo", translation: "the egg" },
      { term: "la bolsa", translation: "the bag", fromTranslator: true },
      { term: "caro", translation: "expensive" },
    ],
  },
  {
    id: "ex-pronounce",
    type: "pronounce",
    phrase: "¿Cuánto cuesta el kilo?",
    translation: "How much is a kilo?",
  },
  {
    id: "ex-rearrange",
    type: "rearrange",
    translation: "Where is the market?",
    answer: ["¿Dónde", "está", "el", "mercado?"],
    distractors: ["la", "hay"],
  },
];
